import type { GameEvent } from "../../engine/types";

export const BIRD_EVENTS: readonly GameEvent[] = [
  {
    id: "b_egg_warm",
    archetypes: ["BIRD"],
    stages: ["egg"],
    weight: 6,
    text: "คุณได้ยินเสียงหัวใจของพ่อแม่ที่นั่งกกไข่อยู่ด้านบน",
    choices: [{ label: "เติบโตต่อไป", outcomes: [{ chance: 1, text: "ไออุ่นทำให้ร่างกายข้างในเปลือกเติบโตเร็วขึ้น", effects: { health: 10 } }] }],
  },
  {
    id: "b_feeding",
    archetypes: ["BIRD"],
    stages: ["nestling", "fledgling"],
    weight: 9,
    text: "พ่อแม่บินกลับมาพร้อมอาหาร",
    choices: [
      {
        label: "อ้าปากร้องให้ดังที่สุด",
        outcomes: [
          { chance: 0.7, text: "คุณได้อาหารคำแรก!", effects: { fullness: 35 } },
          { chance: 0.3, text: "คุณได้อาหาร แต่เสียงดังจนนักล่าได้ยิน", effects: { fullness: 35, safety: -15 } },
        ],
      },
      {
        label: "รอคิว",
        outcomes: [
          { chance: 0.5, text: "พ่อแม่ป้อนคุณเป็นตัวสุดท้าย แต่ก็ได้พอ", effects: { fullness: 20 } },
          { chance: 0.5, text: "อาหารหมดก่อนถึงคิวคุณ", effects: { fullness: 5 } },
        ],
      },
    ],
  },
  {
    id: "b_nest_raid",
    archetypes: ["BIRD"],
    stages: ["egg", "nestling"],
    weight: 3,
    text: "งูตัวหนึ่งกำลังเลื้อยขึ้นมาตามกิ่งไม้ใกล้รัง",
    choices: [
      {
        label: "อยู่นิ่งที่สุด",
        outcomes: [
          { chance: 0.7, text: "พ่อแม่บินกลับมาไล่มันไปได้ทัน", effects: { safety: 5 } },
          { chance: 0.3, text: "งูมาถึงรังก่อนพ่อแม่", effects: { death: "predator" } },
        ],
      },
    ],
  },
  {
    id: "b_first_flight",
    opening: true,
    archetypes: ["BIRD"],
    stages: ["fledgling"],
    requires: { canFly: true, notFlags: ["can_fly"] },
    once: true,
    weight: 15,
    text: "ถึงเวลาหัดบินแล้ว ขอบรังดูสูงกว่าที่คิดไว้เยอะ",
    choices: [
      {
        label: "กระโดดเลย!",
        outcomes: [
          { chance: 0.7, text: "คุณกางปีกร่อนลงพื้นได้สำเร็จ", effects: { safety: 10, addFlags: ["can_fly"] } },
          { chance: 0.3, text: "คุณตกลงพื้นแรงไปหน่อย ขาเจ็บนิดหน่อย", effects: { health: -20, addFlags: ["can_fly", "injured"], cause: "accident" } },
        ],
      },
      { label: "รออีกสักวัน", outcomes: [{ chance: 1, text: "พ่อแม่บินมาป้อนอาหารให้อีกมื้อ", effects: { fullness: 15 } }] },
    ],
  },
  {
    id: "b_ground_fledgling",
    archetypes: ["BIRD"],
    stages: ["fledgling"],
    weight: 4,
    text: "คุณออกมาเดินเล่นบนพื้น ยังบินได้ไม่คล่อง",
    choices: [
      {
        label: "หลบอยู่ใต้พุ่มไม้",
        outcomes: [
          { chance: 0.8, text: "พ่อแม่คอยส่งเสียงเตือนภัยอยู่ใกล้ๆ", effects: { safety: 10 } },
          { chance: 0.2, text: "แมวจรตัวหนึ่งเห็นคุณ คุณกระพือปีกหนีขึ้นกิ่งไม้ทัน", effects: { health: -10, safety: -10, cause: "predator" } },
        ],
      },
      {
        label: "เดินสำรวจต่อ",
        outcomes: [
          { chance: 0.6, text: "คุณเจอหนอนตัวอ้วน", effects: { fullness: 20 } },
          { chance: 0.3, text: "คุณหลงห่างจากพ่อแม่", effects: { safety: -15 } },
          { chance: 0.1, text: "นักล่าเร็วกว่าปีกที่ยังไม่แข็งแรงของคุณ", effects: { death: "predator" } },
        ],
      },
    ],
  },
  {
    id: "b_migration",
    archetypes: ["BIRD"],
    stageTags: ["adult"],
    requires: { canFly: true },
    weight: 2.5,
    text: "อากาศเริ่มเปลี่ยน นกหลายตัวรวมฝูงเตรียมบินอพยพ",
    choices: [
      {
        label: "บินอพยพไปด้วย",
        outcomes: [
          { chance: 0.75, text: "คุณถึงที่หมายที่อบอุ่นและอาหารอุดมสมบูรณ์", effects: { move: "far", fullness: 25, safety: 10 } },
          { chance: 0.2, text: "การเดินทางไกลหลายพันกิโลเมตรทำให้คุณหมดแรง", effects: { move: "far", health: -20, fullness: -20, cause: "disaster" } },
          { chance: 0.05, text: "พายุกลางทางพัดฝูงกระจัดกระจาย", effects: { death: "disaster" } },
        ],
      },
      { label: "อยู่ที่นี่ต่อ", outcomes: [{ chance: 1, text: "อาหารเริ่มหายากขึ้นทุกวัน", effects: { fullness: -15 } }] },
    ],
  },
  {
    id: "b_glass",
    archetypes: ["BIRD"],
    stages: ["fledgling", "adult"],
    requires: { canFly: true, habitat: ["urban", "forest", "grassland"] },
    weight: 1,
    threatenedWeight: 2,
    text: "ข้างหน้ามีอาคารกระจกใส สะท้อนท้องฟ้าจนดูเหมือนทางโล่ง",
    choices: [
      { label: "บินอ้อม", outcomes: [{ chance: 1, text: "คุณบินอ้อมไปอย่างปลอดภัย", effects: { fullness: -5 } }] },
      {
        label: "บินตรงไป",
        outcomes: [
          { chance: 0.4, text: "คุณหักเลี้ยวได้ทันในวินาทีสุดท้าย" },
          { chance: 0.5, text: "ปัง! คุณชนกระจกจนมึนไปพักใหญ่", effects: { health: -30, cause: "human" } },
          { chance: 0.1, text: "แรงกระแทกรุนแรงเกินไป", effects: { death: "human" } },
        ],
      },
    ],
  },
  {
    id: "b_nest_build",
    archetypes: ["BIRD"],
    stageTags: ["adult"],
    requires: { flags: ["has_mate"] },
    weight: 8,
    text: "คุณกับคู่ช่วยกันสร้างรัง",
    choices: [
      { label: "เลือกกิ่งไม้สูงที่ปลอดภัย", outcomes: [{ chance: 1, text: "รังของคุณมั่นคงและพ้นมือนักล่า", effects: { safety: 15, fullness: -10 } }] },
      { label: "สร้างเร็วๆ ในพุ่มไม้", outcomes: [{ chance: 1, text: "รังเสร็จไว แต่ไม่ค่อยมิดชิด", effects: { fullness: -5, safety: -5 } }] },
    ],
  },
  {
    id: "b_raise_chicks",
    archetypes: ["BIRD"],
    stageTags: ["adult"],
    requires: { flags: ["parent"] },
    weight: 6,
    text: "ลูกนกในรังร้องหิวไม่หยุด",
    choices: [
      { label: "บินหาอาหารมาป้อนทั้งวัน", outcomes: [{ chance: 1, text: "ลูกๆ ขนขึ้นเต็มตัวและบินออกจากรังได้สำเร็จ", effects: { fullness: -25, removeFlags: ["parent"] } }] },
      { label: "แบ่งเวลาหาอาหารให้ตัวเองด้วย", outcomes: [{ chance: 1, text: "ลูกๆ โตช้าหน่อย แต่ก็ออกจากรังได้", effects: { fullness: -5, removeFlags: ["parent"] } }] },
    ],
  },
];
